// extracted by mini-css-extract-plugin
module.exports = {"project":"TasksByProjects_project__2jB0P","project-dark":"TasksByProjects_project-dark__3fN6M","title":"TasksByProjects_title__2654O","message":"TasksByProjects_message__2mgmO"};